import { AsyncDataProvider } from 'modules/data-providers';
import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { getRequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { getRuleTypeByEditMode } from 'pages/requestForm/utils/helpers';
import { memo, useCallback } from 'react';
import { useGetNetSuiteAmortizationSchedules } from 'shared/data/webApp/v1';

import { NetSuiteAmortizationSchedulesDataProviderProps } from './NetSuiteAmortizationSchedulesDataProvider.types';

const NetSuiteAmortizationSchedulesDataProvider = memo<NetSuiteAmortizationSchedulesDataProviderProps>((props) => {
    const { children, sublistType } = props;

    const request = useSelector(requestSelector);
    const editMode = useSelector((state) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const { id: requestId, companyId } = request;

    const { refetch } = useGetNetSuiteAmortizationSchedules(
        {
            query: {
                requestId,
                ruleType,
                startFrom: 0,
                companyId,
                sublistType,
            },
        },
        {
            enabled: false,
        }
    );

    const onLoad = useCallback(async () => {
        const { data } = await refetch();

        return (
            data?.values.map((value) => ({
                id: value.id,
                text: value.name || value.id,
            })) || []
        );
    }, [refetch]);

    return (
        <AsyncDataProvider
            cacheStorageId={`requestOptions.netSuiteAmortizationSchedules.${requestId}`}
            pageSize={1000}
            onLoad={onLoad}
        >
            {children}
        </AsyncDataProvider>
    );
});

export default NetSuiteAmortizationSchedulesDataProvider;
